import { render, staticRenderFns } from "./camera_list.vue?vue&type=template&id=74d70779&scoped=true&"
import script from "./camera_list.vue?vue&type=script&lang=js&"
export * from "./camera_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d70779",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74d70779')) {
      api.createRecord('74d70779', component.options)
    } else {
      api.reload('74d70779', component.options)
    }
    module.hot.accept("./camera_list.vue?vue&type=template&id=74d70779&scoped=true&", function () {
      api.rerender('74d70779', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_sb/cameras/tabs/camera_list.vue"
export default component.exports